export default "__VITE_ASSET__Cm9rNQ6E__"